import { Swiper, Autoplay, EffectFade } from 'swiper/js/swiper.esm.js';

export default class BgImgSlider {
  constructor(bgImgSlider) {

    Swiper.use([Autoplay, EffectFade]);

    var mySwiper = new Swiper(bgImgSlider, {
      // Optional parameters
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      effect: 'fade',
      //fadeEffect: {
      //  crossFade: true
      //},
      speed: 2000,
    });
  }
}
